import './set_comments.css'
import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import swal from 'sweetalert';

import { menu_suppliers_referenceSend } from '../../../../services/purchase_service';


function Set_comments({open_comment_modal,setOpen_comment_modal,commchoice,setCommchoice}){


  const [errorText,setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [comment,setcomment]=useState('');

  useEffect(()=>{
    //console.log(open_comment_modal.get('comment'));
    setcomment(open_comment_modal.get('comment') && open_comment_modal.get('comment')!=="null"?open_comment_modal.get('comment'):'');
  },[])

  function submit_refuse_comment() {
    setErrorText("");
    if(comment===''){
      setErrorText("Champ vide !");
    }else{
      setWaiting(true);
      open_comment_modal.set('comment',comment);
      menu_suppliers_referenceSend(open_comment_modal)
        .then((response) => {
          setWaiting(false);
          swal("Le fournisseur sera bientôt notifié !", {
            icon: "success",
            buttons: true,
          }).then((willDelete) => {
              if (willDelete) {
          }})
          setOpen_comment_modal(null);
          let tmp = [...commchoice];
          tmp[open_comment_modal.get('id')] = comment;
          setCommchoice(tmp);
        }).catch(err=>{
            //console.log(err.response);
            setWaiting(false);   
        });
    }
        
  }

     

    return (
      <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_comment_modal!=null?true:false} onClose={()=>setOpen_comment_modal(null)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Votre message</DialogTitle>
        <DialogContent>
          <div>
                {
                    errorText == "" 
                    ?<></>
                    :<p className={errorText ? "error" : "valid-champ"}>
                            {errorText}
                        </p>
                }

              <div style={{width:"100%",marginTop:"5px"}} >
              <TextField
                  id="outlined-multiline-flexible"
                  label="Message"
                  variant='outlined'
                  multiline
                  minRows={4}
                  defaultValue={comment}
                  onChange={(e)=>setcomment(e.target.value)} 
                  style={{width:"100%"}}
                />
              </div>
          </div>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
              <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon className="my_icon" />} onClick={()=>setOpen_comment_modal(null)} >
                  Annuler
              </Button>
              <Button variant="contained" className="submit_but valide_but" startIcon={<SendIcon className="my_icon" />} onClick={submit_refuse_comment} >
                  Envoyer
              </Button> 
            </div>
          </div>
        </DialogActions>

        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

      </Dialog>
    )
}

export default Set_comments
